<template>
  <div class="">
    <div class="container">
      <div class="content">
        <!--文章标题模块-->
        <div class="biaoti">
          <h1 class="" :title="detailTitle">{{ detailTitle }}</h1>
          <div class="return_back" @click="goback()">返回上一页</div>
        </div>
        <!--文章标题模块-->
        <!--文章内容模块-->
        <div class="single_content" id="contentstart">
          <!--内页顶部广告位-->
          <div class="ceo-ad ceo-ads">
            <!--广告按钮-->
            <a href="/" target="_blank"
              ><img
                src="https://image.manmcz.com/wp-content/uploads/2024/11/2024110607115519.png"
            /></a>
          </div>

          <fieldset class="erphpdown" id="erphpdown">
            <legend>资源下载</legend>
            此资源为VIP专享资源
            <div class="erphpdown-down" @click="download()">立即下载</div>

            <div class="erphpdown-down" @click="downmodel()" v-if="is_model == 2">立即下载模型</div>
            <img :src="image_cover" alt="" />
          </fieldset>
        </div>
        <!--文章内容模块-->

        <!--版权-->
        <div class="single_cop">
          <p class="">
            1. 本站所有资源来源于本司画师手动所画！<br />
            2. 本站提供的素材、模板等等其他资源，均需购买后方可使用！<br />
            3. 如有链接无法下载、失效或广告，请联系管理员处理！<br />
          </p>
        </div>
      </div>
    </div>
    <div class="mengban" v-if="loginShow">
      <div class="loginbox" v-if="isLogin">
        <div class="loginbox_left">
          <div class="login_title">
            <h3>登录</h3>
            <p class="title_minor">
              <em></em>
              <span>Hi~欢迎来到星空素材网</span>
              <em></em>
            </p>
          </div>
          <el-input
            v-model="username"
            class="input_box"
            placeholder="请输入用户名/邮箱"
          >
            <template #prefix>
              <img src="../../src/assets/login/user.png" alt="" />
            </template>
          </el-input>
          <el-input
            v-model="password"
            class="input_box"
            placeholder="请输入密码"
            type="password"
          >
            <template #prefix>
              <img src="../../src/assets/login/password.png" alt="" />
            </template>
          </el-input>

          <div class="login_btn bgcolor" @click="login_btn()">立即登录</div>
          <div class="tishi_btn">抖音昵称及账号在抖音平台不允许修改</div>
          <div class="bottom_box">
            <div class="box_left" @click="isLogin = false">
              没有账号？立即注册
            </div>
            <div class="box_right"></div>
          </div>
        </div>
        <div class="loginbox_right"></div>
        <img
          class="cha"
          @click="loginShow = false"
          src="../../src/assets/index/cha.png"
          alt=""
        />
      </div>
      <div class="loginbox registerbox" v-else>
        <div class="loginbox_left">
          <div class="login_title">
            <h3>注册</h3>
            <p class="title_minor">
              <em></em>
              <span>Hi~欢迎来到星空素材网</span>
              <em></em>
            </p>
          </div>
          <el-input v-model="email" class="input_box" placeholder="请输入邮箱">
            <template #prefix>
              <img src="../../src/assets/login/email.png" alt="" />
            </template>
          </el-input>
          <el-input
            v-model="username"
            class="input_box"
            placeholder="请输入用户名"
          >
            <template #prefix>
              <img src="../../src/assets/login/user.png" alt="" />
            </template>
          </el-input>
          <el-input
            v-model="password"
            class="input_box"
            placeholder="请输入您的密码"
            type="password"
          >
            <template #prefix>
              <img src="../../src/assets/login/password.png" alt="" />
            </template>
          </el-input>
          <el-input
            v-model="confirm_password"
            class="input_box"
            placeholder="请再次输入密码"
            type="password"
          >
            <template #prefix>
              <img src="../../src/assets/login/password.png" alt="" />
            </template>
          </el-input>
          <div class="xieyi">
            <input
              v-model="isAgree"
              id="agreement"
              name="agreen"
              type="checkbox"
              class="agreen_btn"
              required=""
            />
            我已阅读并同意 <a href="#">《注册协议》</a>
          </div>
          <div class="login_btn bgcolor" @click="register_btn()">立即注册</div>
          <div class="tishi_btn">抖音昵称及账号在抖音平台不允许修改</div>

          <div class="bottom_box">
            <div class="box_left" @click="isLogin = true">
              已有账号？立即登录
            </div>
          </div>
        </div>
        <div class="loginbox_right"></div>
        <img
          class="cha"
          @click="loginShow = false"
          src="../../src/assets/index/cha.png"
          alt=""
        />
      </div>
    </div>
    <footer>
      <div class="ceo_grid">
        <div class="ceo_grid1">
          <a href="" target="_blank" class="foot-logo ceo-display-block"
            ><img
              src="http://image.manmcz.com/wp-content/uploads/2024/11/2024110608271095.png"
          /></a>
          <p>本站提供高质量简笔画多人物素材推荐有价值的好东西资源分享。</p>
        </div>
      
      </div>

      <div class="foot_cop">
        <div class="ceo-float-left">
          <span>该版权为山西壹拾贰网络科技有限公司版权所有</span>
          <a
            href="http://www.beian.gov.cn/"
            target="_blank"
            rel="noreferrer nofollow"
            ><img
              src="https://jianbihua.manmcz.com/wp-content/themes/ceomax/static/images/ceo-110.png"
              height="6"
          /></a>
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            rel="noreferrer nofollow"
            >晋ICP备2024033569号-2</a
          >
        </div>
        <div class="ceo-float-right ceo-visible@s">
          <span
            >Theme By
            <a
              href="https://www.ceotheme.com/"
              target="_blank"
              rel="noreferrer nofollow"
              >CeoTheme</a
            ></span
          >
        </div>
      </div>
    </footer>
  </div>
</template>
<script setup>
import { useRouter, useRoute } from "vue-router";
const router = useRouter();
const route = useRoute();
import {
  register,
  login,
  getsortData,
  getData,
  getUserinfo,
  saveUserinfo,
  index,
  downData,downModel
} from "@/api/api.js";
import { ref, reactive, onMounted, onBeforeUnmount } from "vue";
import { useTheme } from "@/theme";
import request from "@/utils/request"; // 引入 axios 实例
import { ElMessage } from "element-plus";
const { themeState, toggleTheme } = useTheme(); // 获取全局状态和方法
const detailId = route.query.id;
const detailTitle = route.query.post_title;
const image_cover = route.query.image_cover;
const is_model = route.query.is_model;
const loginShow = ref(false);
const isLogin = ref(true);
const username = ref("");
const password = ref("");
const confirm_password = ref("");
const email = ref("");
const isAgree = ref(false);
const isUserLogin = ref(localStorage.getItem("token"));
const login_btn = () => {
  if (username.value && password.value) {
    const formData = new FormData();
    formData.append("username", username.value);
    formData.append("password", password.value);

    login(formData).then((res) => {
      console.log(res);
      if (res.code === 100) {
        localStorage.setItem("token", res.data.token);
        ElMessage.success("登录成功");
        isUserLogin.value = res.data.token;
        loginShow.value = false;
        // isLogin.value = false;
      }
    });
  } else {
    ElMessage.error("用户名或密码不能为空");
  }
};
const register_btn = () => {
  if (!isAgree.value) {
    ElMessage.error("请先同意协议");
    return;
  }
  if (
    email.value &&
    username.value &&
    password.value &&
    confirm_password.value
  ) {
    if (password.value === confirm_password.value) {
      const formData = new FormData();
      formData.append("username", username.value);
      formData.append("password", password.value);
      formData.append("email", email.value);
      formData.append("confirm_password", confirm_password.value);
      register(formData).then((res) => {
        console.log(res);
        if (res.code === 100) {
          ElMessage.success("注册成功");
        }
      });
    } else {
      ElMessage.error("两次密码输入不一致");
    }
  } else {
    ElMessage.error("邮箱、用户名、密码不能为空");
  }
};
const openUrl = (url) => {
  if (url) {
    window.open(url, "_blank");
  }
};

onMounted(() => {
  // getIndex();
  setRemUnit();
  window.addEventListener("resize", setRemUnit);
});
const getIndex = () => {
  index().then((res) => {
    console.log(res);
    if (res.code === 100) {
      // caogaoList.value = res.data.caogao_list;
      // bannerList.value = res.data.banner_list;
    }
  });
};
const download = () => {
  downData({
    id: detailId,
    token: localStorage.getItem("token"),
  }).then((res) => {
    console.log(res);
    if (res.code === 100) {
      // ElMessage.success("下载成功！");
      let url = res.data;

      // 检查 URL 是否包含 http:// 并替换为 https://
      if (url.startsWith("http://")) {
        url = url.replace("http://", "https://");
      }
      console.log(url, "url");
      window.location.href = url;
      // window.open(url);
      // openUrl(url);
    } else if (
      res.msg == "token值不能为空" ||
      res.msg == "登陆已过期请重新登陆"
    ) {
      loginShow.value = true;
    }
  });
};

const downmodel = () => {
  downModel({
    id: detailId,
    token: localStorage.getItem("token"),
  }).then((res) => {
    console.log(res);
    if (res.code === 100) {
      // ElMessage.success("下载成功！");
      let url = res.data;

      // 检查 URL 是否包含 http:// 并替换为 https://
      if (url.startsWith("http://")) {
        url = url.replace("http://", "https://");
      }
      console.log(url, "url");
      window.location.href = url;
    } else if (
      res.msg == "token值不能为空" ||
      res.msg == "登陆已过期请重新登陆"
    ) {
      loginShow.value = true;
    }
  });
};

const setRemUnit = () => {
  const baseSize = 16;
  const scale = document.documentElement.clientWidth / 1920;
  document.documentElement.style.fontSize =
    baseSize * Math.min(scale, 2) + "px";
};
const goback = () => {
  router.push({ path: "/" });
};
onBeforeUnmount(() => {
  window.removeEventListener("resize", setRemUnit);
});
</script>
  
<style lang="scss" scoped>
.container {
  width: 100%;
  background: url("../../src/assets/index/headerbg.jpg");
  background-size: cover;
  padding: 1.875rem; /* 30px / 16px */
  box-sizing: border-box;
  .content {
    background: #fff;
    padding: 1.875rem; /* 30px / 16px */
    .biaoti {
      display: flex;
      align-items: center;
      .return_back {
        font-size: 1.275rem; /* 14px / 16px */
        color: #0484ff;
        margin-left: 1.25rem; /* 20px / 16px */
        cursor: pointer;
        font-weight: bold;
      }
    }
    h1 {
      font-size: 2rem; /* 15px / 16px */
      margin-bottom: 1.25rem; /* 20px / 16px */
    }
    .single_content {
      img {
        width: 100%;
        border-radius: 0.25rem; /* 4px / 16px */
      }
    }
    .erphpdown {
      margin: 2.375rem 0 !important; /* 38px / 16px */
      border: 1px solid #ffffff00 !important;
      border-radius: 0.3125rem; /* 5px / 16px */
      background: #f5f6f8;
      padding: 0.9375rem 1.5625rem 1.5625rem !important; /* 15px / 16px, 25px / 16px, 25px / 16px */
      font-size: 1.275rem !important; /* 14px / 16px */
      position: relative;
      line-height: 1.5 !important;
      legend {
        color: #0484ff;
        font-weight: 400;
        background: #fff;
        font-size: 1.5rem; /* 12px / 16px */
      }
      .erphpdown-down {
        border-radius: 1.25rem; /* 20px / 16px */
        background: #03a9f4;
        color: #fff !important;
        padding: 0.4375rem 1.125rem 0.5rem; /* 7px / 16px, 18px / 16px, 8px / 16px */
        line-height: 1;
        text-decoration: none !important;
        font-size: 1rem;
        display: inline-block;
        margin-left: 0.5rem; /* 8px / 16px */
        cursor: pointer;
      }
      img {
        margin-top: 1.25rem; /* 20px / 16px */
      }
    }
    .single_cop {
      background: #f5f6f8;
      color: #b4b4b4;
      font-size: 1rem;
      line-height: 1.8;
      position: relative;
      margin-bottom: 1.25rem; /* 20px / 16px */
      padding: 0.9375rem 1.8125rem 0.9375rem 0.9375rem; /* 15px / 16px, 29px / 16px, 15px / 16px, 15px / 16px */
      border-radius: 0.25rem; /* 4px / 16px */
    }
  }
}
</style>
  